<template>
    <v-card color="secondary" class="primary--text">
        <v-img :src="image" height="10rem">
            <div class="reserved" v-if="reserved">
                <span class="text">Rezervováno</span>
            </div>
        </v-img>

        <v-card-title primary-title>
            <div>
                <div><strong>{{title}}</strong></div>
                <span style="line-height: 1em; font-size: 0.85rem;">{{description}}</span>
            </div>
        </v-card-title>

        <v-card-actions>
            <v-btn color="primary" :href="link" target="_blank" style="text-transform: none; font-size: 0.9rem; padding-top: 0.15rem">Obchod</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        name: "WeddingGift",
        props: {
            title: {
                type: String,
                required: true
            },
            image: {
                type: String,
                default: null
            },
            link: {
                type: String,
                default: null
            },
            description: {
                type: String,
                default: null
            },
            reserved: {
                type: Boolean,
                default: false
            }
        },
    };
</script>
<style scoped lang="stylus">
    .reserved {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.25);

        .text {
            color: darkred;
            position: absolute;
            left: 50%;
            top: 50%;
            font-size: 2rem;
            font-weight: bold;
            transform: translate(-50%, -50%) rotate(-20deg);
        }
    }
</style>